<template>
  <div>
    <div class="overlay" v-if="isLoading">
      <div class="spinner-container">
        <div class="loader" id="loader-1"></div>
        <div class="text white-text">
          <slot name="text"></slot>
        </div>
      </div>
    </div>
    <slot></slot>
  </div>
</template>
<script>
export default {
  props: {
    isLoading: {
      type: Boolean,
      required: true,
    },
  },
};
</script>
<style>
.overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  border-radius: 24px 24px 0 0;
  justify-content: center;
  align-items: center;
  z-index: 6;
  background-color: rgba(0, 0, 0, 0.5);
}

.spinner-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 50vh;
}

.text {
  margin-top: 10px;
  text-align: center;
  color: var(--color-gray);
}

.white-text {
  color: white;
}
</style>
